import styled, { css } from 'styled-components/macro';

import { darken } from 'polished';

import ToolbarDropdown from 'components/utility/GenericComponent/ToolbarDropdown/ToolbarDropdown';
import Box from 'components/elements/Box';

import colors from 'styles/themes/colors';

export const ArtistPageLink = styled.a`
  display: inline-block;
  color: #001247;
  text-decoration-skip-ink: auto;
  cursor: pointer;

  &:hover {
    color: ${darken(0.1, '#001247')};
  }

  &:focus:not(:active) {
    border: 1px dotted ${({ theme }): string => theme.NightBlue};
  }
`;

export const Cell = styled('td')<any>`
  padding: 1em 0.5em;
  color: ${({ theme }): string => theme.Black};
  vertical-align: ${({ verticalAlign }): string =>
    verticalAlign ? verticalAlign : 'inherit'};
  border-bottom: 1px solid ${({ theme }): string => theme.colors.LightGrey};
  text-align: left;
  width: 18%;

  &:first-of-type {
    text-align: left;
    width: 22%;
  }
`;

export const Container = styled('section')<any>`
  padding: ${({ theme }): string => theme.spacing.medium};
  background: white;

  @media screen and (max-width: 50em) {
    margin: 0.5em;
    padding: 10px;
  }

  ${({ theme, isMobileView }): string =>
    isMobileView
      ? `
      @media screen and (max-width: 50em) {
        margin: ${theme.spacing.medium};
      }
      @media screen and (max-width: 40em) {
        margin: 0 ${theme.spacing.small} ${theme.spacing.small};
      }
      `
      : ''}

  @media screen and (min-width: 50em) {
    width: ${({ theme }): number => theme.layout.smallScreen * 100}%;
    padding: 1.9em 2em;
    margin: 0 auto;
  }

  @media screen and (min-width: 80em) {
    width: ${({ theme }): number => theme.layout.largeScreen * 100}%;
  }
`;

export const H2 = styled('h2')<any>`
  margin: 0 0 0 0.4em;
  font-weight: 700;
`;

export const Head = styled.thead<any>`
  tr {
    vertical-align: bottom;

    &:hover {
      background: none;
    }
  }
`;

const headStyles = css`
  color: ${colors.MediumGrey};
  font-size: 0.75rem;
  font-weight: 600;
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 1px;
`;

export const HeadCell = styled('th')<any>`
  ${headStyles};
`;

export const StyledToolbarDropdown = styled(ToolbarDropdown)`
  position: relative;
  margin-top: 0.5em;
`;

export const ListItem = styled(Box)`
  border-bottom: 1px solid ${({ theme }): string => theme.colors.LightGrey};
`;

export const DateRange = styled('div')<any>`
  text-transform: uppercase;
  font-size: 13px;
  line-height: 15px;
  font-weight: 500;
  color: #8ea6be;
  height: 20px;
  margin: ${({ margin }): string => (margin ? margin : '4px 0 3px 0')};
  letter-spacing: normal;
`;

export const HeadLabel = styled('div')<any>`
  text-transform: none;
  font-size: 16px;
  line-height: 19px;
  font-weight: 600;
  color: #001247;
  letter-spacing: normal;
  ${({ margin }): string => (margin ? `margin: ${margin};` : '')}
`;

export const ValueWrapper = styled('div')<any>`
  margin: ${({ isSmallScreen, margin }): string =>
    margin ? margin : isSmallScreen ? '10px 0 20px 0' : '0'};
  span {
    font-weight: ${({ fontWeight }): string =>
      fontWeight ? fontWeight : 'inherit'} !important;
  }
`;

export const RTDWithLink = styled('div')<any>`
  display: flex;
  justify-content: space-between;
  margin-bottom: 2px;
  font-weight: 600;
  color: ${({ color }): string => (color ? color : 'inherit')};
`;

export const LinksWrapper = styled('div')<any>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin-top: 35px;
`;
